export default Object.freeze({
  Australia: 'Australia',
  USA: 'USA',
  NewZealand: 'New Zealand',
})
